import { RootState } from "redux-features/store";

export const selectUserSelectedChargers = (state: RootState) =>
  state.chargers.chargers;
